import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';
import Options from 'components/form/managed_input/options';

import type { InputProps } from './types';

export default function StateInput({ country, options, value, onChange }: InputProps) {
  if (options.state?.show === false) {
    return null;
  }

  const props: Record<string, any> = {
    hasError: options.state?.hasError,
    label: country.stateLabel,
    required: options.state?.required !== false,
    value: value.state,
    onValueChange: (state: string) => onChange({ ...value, state }),
  };

  if (country.stateType === 'enum') {
    props.type = 'select';
    props.children = <>
      <option value="" />
      <Options labelName="0" options={country.stateOptionsForSelect} valueName="1" />
    </>;
  }

  return <ManagedFormGroup {...props} />;
}
